import {useState} from 'react';

export function useLocalStorage(key, initialValue, reverseArray = false) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue

            if (item) {
                const parsedItem = JSON.parse(item);
                return reverseArray && Array.isArray(parsedItem) ? parsedItem.reverse() : parsedItem;
            } else {
                return initialValue;
            }
        } catch (error) {
            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // A more advanced implementation would handle the error case
            throw new Error(error);
        }
    };

    return [storedValue, setValue];
}
